# Browser support

Our web-based components support versions released over the last year for the following web browsers:

- [Apple Safari](https://www.apple.com/safari/)
- [Google Chrome](https://www.google.com/intl/en/chrome/)
- [Microsoft Edge](https://www.microsoft.com/en-gb/edge?form=MA13FJ)
- [Mozilla Firefox](https://www.firefox.com/en-GB/)

Hirers should use an up-to-date web browser;
unsupported browsers may not be able to access our web-based components or use all of their features.
See the documentation page of each component for more information:

- [Ad Performance Panel](/use-cases/ad-performance/panel#before-you-begin)
- [Ad Selection Panel](/use-cases/job-posting/ad-selection/v2/panel#before-you-begin)
- [Job Ad Preview](/use-cases/job-posting/managing-job-ads/previewing-a-job-ad#browser-support)
- [Questionnaire Panel](/use-cases/job-posting/questionnaires/v2/panel#before-you-begin)
